
import React from 'react';

const AccessSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            アクセス
          </h2>
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-4 text-gray-800">
                  <i className="ri-map-pin-line text-blue-600 mr-2"></i>
                  所在地
                </h3>
                <p className="text-gray-700 mb-4">
                  〒150-0001<br />
                  東京都渋谷区神宮前1-1-1
                </p>
                <p className="text-gray-600">
                  最寄駅から徒歩5分。駐車場も完備しておりますので、お車でもお越しいただけます。
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-4 text-gray-800">
                  <i className="ri-train-line text-blue-600 mr-2"></i>
                  交通アクセス
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• JR山手線「原宿駅」徒歩5分</li>
                  <li>• 東京メトロ千代田線「明治神宮前駅」徒歩3分</li>
                  <li>• 東京メトロ副都心線「明治神宮前駅」徒歩3分</li>
                </ul>
              </div>
              <button 
                onClick={() => window.open('https://maps.google.com', '_blank')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line mr-2"></i>
                Googleマップで開く
              </button>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0977842160!2d139.70273831525394!3d35.67027998019625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca40296d2d1%3A0x7c5d6a1b8b8b8b8b!2z5p2x5Lqs6YO95riL6LC35Yy656We5a6u5YmN!5e0!3m2!1sja!2sjp!4v1620000000000!5m2!1sja!2sjp"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="会社所在地"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessSection;
